
class BuyWith extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-buy-with-add]');
    if (!this.button) return;

    this.addEventListener('change', () => this.sync());
    this.button.addEventListener('click', () => this.add());
    this.sync();
  }

  chosen() {
    return [...this.querySelectorAll('[data-buy-with]:checked')]
      .map((i) => Number(i.dataset.buyWith))
      .filter(Boolean);
  }

  sync() {
    this.button.disabled = this.chosen().length === 0;
  }

  async add() {
    const items = this.chosen().map((id) => ({ id, quantity: 1 }));
    if (!items.length) return;

    const main = Number(this.dataset.main);
    if (main) items.unshift({ id: main, quantity: 1 });

    this.button.disabled = true;
    try {
      await window.CartAPI.add(items, { source: 'buy-with' });
      this.querySelectorAll('[data-buy-with]').forEach((i) => { i.checked = false; });
    } finally {
      this.sync();
    }
  }
}

customElements.define('buy-with', BuyWith);
